export function toPercent(num: number): string {
  return `${num * 100}%`;
}

export const CSS_IN_TO_PX = 96;
